import template from './index.pug'
import ChatInput from './chatinput.js'
import * as echarts from 'echarts'
import { marked } from 'marked';
import DOMPurify from 'dompurify';
export default Vue.extend({
  template: template(),
  components: { ChatInput },
  props: {
    initData: { type: Object, default: null },
    errors: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      messages: [],
      data: {},
      chartInstance: null,
      suggestedPrompts: [],
      chatsHistory: [],
      chatId: null,
      showSidebar: false    
    }
  },
  watch: {
    initData: {
      immediate: true,
      handler() {
        this.initializeData()
      }
    },
    messages: {
      deep: true,
   handler() {
     this.$nextTick(() => {
          this.messages.forEach((msg, index) => {
            if (msg.type === 'chart') {
              let container = this.$refs[`chartContainer_${index}`]
              if (Array.isArray(container)) {
                container = container[0]
              }
              console.log('chart container:', container, container?.nodeName, container instanceof HTMLElement)
              if (!container || msg._chartRendered) return

              const chart = echarts.init(container)
              const option = this.buildEchartsOption(msg.chartData)
              chart.setOption(option)

              this.$set(msg, '_chartRendered', true)
            }
          })
        })
     }
    }
  },
  mounted() {
    this.loadPromts();
    this.loadChats();
  
  },
  created() {
    this.$setPageTitle('AI Infinity')
    this.$setBreadcrumbs([
      { label: this.$t('breadcrumbs.ai-infinity.index'), route: {} }
    ])
  },
  methods: {
     renderMarkdown(mdText) {
    return DOMPurify.sanitize(marked(mdText || ''))
   },
    handleSendMessage(userMessage, files, useDataBase) {
      this.messages.push({ role: 'user', content: userMessage })

      this.$nextTick(() => this.scrollToBottom())

      const formData = new FormData()
      formData.append('chatId', this.chatId)
      formData.append('prompt', this.processPrompt(userMessage))
      formData.append('useDataBase', useDataBase)
      files.forEach(file => formData.append('files', file))

      API.analytics.analyzeData(formData).then(response => {
        try {
          const parsed = JSON.parse(response.data.result)          
          if (parsed.type && parsed.labels && parsed.datasets) {
            if (parsed.descripcion) {
              this.messages.push({
                role: 'assistant',
                content: parsed.descripcion
              })
            }

            this.messages.push({
              role: 'assistant',
              type: 'chart',
              chartData: parsed
            })
          } else {
             this.messages.push({ role: 'assistant', content: response.data.result })
          }
        } catch {
              if(response.data.result=='aiinfinity_notallowed') 
               {
                this.messages.push({ role: 'assistant', content: this.$t(`analytics.aiInfinity.aiNotAllowed`)})
               }
               else{
                this.messages.push({ role: 'assistant', content: response.data.result })
               }          
        }

        this.$nextTick(() => this.scrollToBottom())
      }, errors => {
        this.$notifications.error(this.$t('analytics.aiInfinity.errors'))
        this.errors = errors
      })
    },

buildEchartsOption(data) {
  const isPie = data.type === 'pie'

  const series = data.datasets.map(ds => ({
    name: ds.label,
    type: isPie ? 'pie' : data.type,
    data: isPie
      ? data.labels.map((label, i) => ({
          value: ds.data[i],
          name: label,
          itemStyle: {
            color: Array.isArray(ds.backgroundColor)
              ? ds.backgroundColor[i]
              : ds.backgroundColor
          }
        }))
      : data.labels.map((label, i) => ({
          value: ds.data[i],
          name: label,
          itemStyle: {
            color: Array.isArray(ds.backgroundColor)
              ? ds.backgroundColor[i]
              : ds.backgroundColor
          }
        })),
    ...(isPie ? { radius: '50%' } : {})
  }))

  return {
    tooltip: { trigger: 'item' },
    legend: { bottom: 0 },
    series: series,
    ...(isPie ? {} : {
      xAxis: { type: 'category', data: data.labels },
      yAxis: { type: 'value' }
    })
  }
}
,

    scrollToBottom() {
      const container = this.$refs.messagesContainer
      container.scrollTop = container.scrollHeight
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
    },

    initializeData() {
      this.chatId = crypto.randomUUID()
    },
    applyChat(chatId)
    {
    this.chatId = chatId;  
    var chatHis = this.chatsHistory.find(chat => chat.chatId === chatId);  
    this.messages = []
    var historyMessages = []    
     chatHis.aIChatHistoryDtos.forEach(function(message) {      
     if(message.role=='user')
      {
        console.log(message.content)
        var contentClean = message.content.replace(/Responde con un JSON válido[\s\S]*?"Breve análisis textual del gráfico"\s*}/, '').trim();
        historyMessages.push({ role: 'user', content: contentClean})
      }
      else{
        let parsed;
        try {          
              parsed = JSON.parse(message.content);            
              if (parsed.type && parsed.labels && parsed.datasets) {
                if (parsed.descripcion) {
                  historyMessages.push({
                    role: 'assistant',
                    content: parsed.descripcion
                  })
                }

                historyMessages.push({
                  role: 'assistant',
                  type: 'chart',
                  chartData: parsed
                })
              } else {
                historyMessages.push({ role: 'assistant', content: message.content })
              }
          } catch (error) {
             historyMessages.push({ role: 'assistant', content: message.content })
          }

        
      }        
     });

     this.messages = historyMessages;
    },
    applyPrompt(prompt) {
      this.$refs.chatInputRef.insertPrompt(prompt)
    },

    t(key, options = {}) {
      return this.$t(`analytics.aiInfinity.${key}`, options)
    },

    loadPromts() {
      API.analytics.getPromts().then(({ data }) => {
        this.suggestedPrompts = JSON.parse(JSON.stringify(data))
      })
    },
     loadChats() {
      API.analytics.getChats().then(({ data }) => {
        this.chatsHistory = JSON.parse(JSON.stringify(data))
      })
    },

    processPrompt(userPrompt) {
      const prompt = userPrompt.toLowerCase()

      if (prompt.includes('gráfico') || prompt.includes('gráfica') || prompt.includes('grafico') || prompt.includes('grafica')) {
        let tipo = 'pie'
        if (prompt.includes('barras')) tipo = 'bar'
        else if (prompt.includes('línea') || prompt.includes('line')) tipo = 'line'

        const content = `${userPrompt}
Responde con un JSON válido con esta estructura:
{
  "type": "bar" | "pie" | "line",
  "labels": [],
  "datasets": [{
    "label": "",
    "data": [],
    "backgroundColor": []
  }],
  "descripcion": "Breve análisis textual del gráfico"
}`

        return content
      }

      return userPrompt
    }
  }
})
